import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import {
    TreatmentWizardSettingsStore,
    TreatmentWizardSettingsState,
} from './treatment-wizard-settings.store';
import { combineLatest, Observable } from 'rxjs';
import { FamilyWizardModel } from '../../models/family-wizard.model';
import { map } from 'rxjs/operators';
import { CommonWizardService } from '../../../core/services/common-wizard/common-wizard.service';
import { ServiceWizard } from '../service-wizard/service-wizard.model';
import { FamilyFolderModel } from '../../models/family-folder.model';
import { ProductWizard } from '../product-wizard/product-wizard.model';
import { PackWizard } from '../pack-wizard/pack-wizard.model';

@Injectable({ providedIn: 'root' })
export class TreatmentWizardSettingsQuery extends Query<
    TreatmentWizardSettingsState
> {
    constructor(
        protected store: TreatmentWizardSettingsStore,
        private commonWizardService: CommonWizardService
    ) {
        super(store);
    }

    /*-----------*/
    /** GETTERS */
    /*----------*/

    get stepStack() {
        return this.getValue()?.stepStack;
    }

    get shippingEnabled() {
        return this.getValue()?.shippingEnabled;
    }

    get cancelShippingUserChecked() {
        return this.getValue()?.cancelShippingUserChecked;
    }

    get confirmShippingUserChecked() {
        return this.getValue()?.confirmShippingUserChecked;
    }

    get shippingAddress() {
        return this.getValue()?.shippingAddress;
    }

    get families() {
        return this.getValue()?.families;
    }

    get selectFamiliesDistinct(): Observable<FamilyWizardModel[]> {
        return this.select('families').pipe(
            map((families) => {
                return this.commonWizardService.getFamiliesCommonFactor(
                    families
                );
            })
        );
    }

    selectFamilyFolderTree(
        familiesWizard$: Observable<FamilyWizardModel[]>,
        servicesWizard$: Observable<ServiceWizard[]>,
        productsWizard$: Observable<ProductWizard[]>,
        packsWizard$: Observable<PackWizard[]>
    ) {
        return this.commonWizardService.selectFamilyFolderTree(
            familiesWizard$,
            servicesWizard$,
            productsWizard$,
            packsWizard$
        );
    }
}
